export default __webpack_public_path__ + "static/media/C3.180c50ac.jpg";